/**
 * Payment-related TypeScript types
 * SHARED between frontend and backend
 * ABSOLUTE RULE: NO 'any' types allowed
 */

import { Timestamp } from 'firebase/firestore';

/**
 * Credit Package definition
 * Matches spec 3.7.2
 */
export interface CreditPackage {
  id: string;
  name: string;
  credits: number;
  priceCAD: number;
  badge?: 'LIMITED TIME SPECIAL' | 'BEST VALUE';
  highlighted?: boolean;
  description?: string;
}

/**
 * PayPal order creation request
 * Sent from frontend to createPayPalOrder function
 */
export interface CreatePayPalOrderRequest {
  packageId: string;
}

/**
 * PayPal order creation response
 * Returned from createPayPalOrder function
 */
export interface CreatePayPalOrderResponse {
  orderId: string; // PayPal order ID
  transactionId: string; // Our internal transaction ID
}

/**
 * Transaction document stored in Firestore
 * Collection: /transactions/{transactionId}
 */
export interface TransactionDocument {
  transactionId: string;
  userId: string;
  packageId: string;
  packageName: string;
  credits: number;
  amountCAD: number;
  paypalOrderId: string;
  paypalCaptureId?: string;
  status: TransactionStatus;
  createdAt: Timestamp;
  completedAt?: Timestamp;
  errorMessage?: string;
}

/**
 * Transaction status enum
 */
export enum TransactionStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

/**
 * PayPal webhook payload (simplified)
 * Full payload is more complex, but we only need these fields
 */
export interface PayPalWebhookPayload {
  event_type: string;
  resource: {
    id: string; // Capture ID
    amount: {
      currency_code: string;
      value: string;
    };
    custom_id?: string; // Our transaction ID
  };
}

/**
 * Credit fulfillment result
 * Returned from credit fulfillment function
 */
export interface CreditFulfillmentResult {
  success: boolean;
  creditsAdded: number;
  newBalance: number;
  transactionId: string;
}
